import { render, staticRenderFns } from "./ktxc-MULTIPLE_CHOICE.vue?vue&type=template&id=5a663ad7&scoped=true"
import script from "./ktxc-MULTIPLE_CHOICE.vue?vue&type=script&lang=js"
export * from "./ktxc-MULTIPLE_CHOICE.vue?vue&type=script&lang=js"
import style0 from "./ktxc-MULTIPLE_CHOICE.vue?vue&type=style&index=0&id=5a663ad7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a663ad7",
  null
  
)

export default component.exports